import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { PagingQuery, Table } from 'tea-component';
import { useHistory, useSelector } from 'umi';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { TopchartTableProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { MetricsTableCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/MetricsTableCloums';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import DatabrainBubbleTip from '@/pages/intelligence/components/TableComponents/components/FirstRow/DatabrainBubbleTip';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import {
  TableCheckboxHeader,
  TableCheckboxRender,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import {
  // getPCConsoleCloumsByPageId,
  getDetailStatsSubTabName,
} from '@/pages/intelligence/pages/TopCharts/PCGames/_config/utils';
import classNames from 'classnames';
import { PCConsolePageId } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/type';
// import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { getPriceEcharts } from '@/pages/intelligence/pages/TopCharts/PCGames/_config/tableVisibleCloums';
import { DetailsCloums } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { changeSingleTimeToRange } from '@intelligence/utils/filterUtils';
import { getGameRankDetails } from '@intelligence/utils/tableUtils';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { getPlatformIconsImg, iconSortFun } from '@intelligence/utils/common';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { Bubble } from '@home/components/TeaComponents';
import { formatReleaseTime } from '@home/components/NavHeader/sreachContext/utils';
import { JumpType, navigate } from '@home/utils/utils';
import CommonColumns from '@intelligence/pages/TopCharts/_config/TableCloums/CommonCloums';
import { isEmpty } from '@intelligence/v3/utils/common';
import { getPublisherClassText } from '@intelligence/pages/TopCharts/PCConsoleGames/utils';

import type { IMetricExplanationTipsClickHandler } from '@intelligence/v3/components/MetricExplanationTips';
import type { IGenreSource, IOptionWithChildren } from '@intelligence/components/GenreSelect/types';

const { injectable } = Table.addons;
interface IPublisherInfoItem {
  publisher: string;
  publisher_addr: string;
}

interface ActiveUsersTableProps extends TopchartTableProps {
  selectDataSources: string[];
  entityType: string;
  dateType: string;
  startDate?: string;
  endDate?: string;
  pageId: PCConsolePageId;
  genreSource: IGenreSource;
  genreOptionsMap?: IRecord<IOptionWithChildren[]>;
  dataSourcesColumns: any[];
  deviceSortByList: any[];
  gameHightList?: string[];
  checkboxDisableTip?: React.ReactNode;
  disableChckekList?: string[];
  onTagClick: (type: string, tag: string) => Promise<void>;
  onTableSortChage: (e: SortByItemType) => any;
  jumpType?: JumpType;
  jumpQuery?: IRecord;
  gameInfoJumpQuery?: IRecord;
  onMetricExplanationClick?: IMetricExplanationTipsClickHandler;
}
export default function MetricsTableTable(props: ActiveUsersTableProps) {
  const {
    loading,
    records = [],
    tableTotal = 0,
    pageSortAttr,
    tableSelection,
    tableSelectionAll,
    onTableSortChage,
    onTablePagingChange,
    onTableCheckGame,
    pageId,
    entityType,
    dateType,
    startDate,
    endDate,
    genreSource,
    genreOptionsMap,
    dataSourcesColumns,
    deviceSortByList,
    gameHightList,
    checkboxDisableTip,
    disableChckekList,
    onTagClick,
    jumpType,
    jumpQuery,
    gameInfoJumpQuery,
    onMetricExplanationClick,
  } = props;

  const { isOperate } = useSelector((state) => {
    // @ts-ignore
    const { isOperate } = state[FILTER_EXTEND_NAMESPACE];
    return {
      isOperate,
    };
  });
  const { filterExtend, setFilterExtend } = useFilterExtend({});
  const { locale, formatMessage, isCN } = useIntlExtend();
  const {
    tablePageIndex,
    tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    currentOrderSource,
    currentOrderDevice,
  } = pageSortAttr || {};
  const history = useHistory();
  const shouldShowPublisherHoverBubble = ['PCConsoleMetricsTable', 'PCConsoleDataBrainCalibration'].includes(pageId);
  const defaultPageSize = 100;
  const [pageIndex, setPageIndex] = useState(tablePageIndex || 1);
  const [pageSize, setPageSize] = useState(tablePageSize || defaultPageSize);
  const [selectList, setSelectList] = useState(tableSelection);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    setPageIndex(tablePageIndex);
    setPageSize(tablePageSize);
  }, [tablePageIndex, tablePageSize]);

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || defaultPageSize);
    onTablePagingChange(e);
  };

  const onSortChage = (e: SortByItemType) => {
    onTableSortChage(e);
  };

  useEffect(() => {
    setSelectList(tableSelection);
  }, [tableSelection]);

  const getMetricValueOfCvm = (cvm: any, metricKey: string) => {
    // console.log('cvmcvm234234', cvm);
    // console.log('metricKey', metricKey);

    if (!cvm || !metricKey) {
      return undefined;
    }

    // TopCharts 的 steam_tag / game_mode 为顶层字段，不在 metric_list 中
    if (
      (metricKey === 'steam_tag' || metricKey === 'game_mode') &&
      Object.prototype.hasOwnProperty.call(cvm, metricKey)
    ) {
      return cvm?.[metricKey];
    }

    const metrics = cvm?.metric_list || [];
    const metric = metrics.find((item: any) => item.title === metricKey);
    return metric;
  };

  const getPublisherInfoList = (cvm: any): IPublisherInfoItem[] => {
    if (Array.isArray(cvm?.publishers) && cvm.publishers.length > 0) {
      return cvm.publishers.filter((item: IPublisherInfoItem) => !isEmpty(item?.publisher));
    }

    if (isEmpty(cvm?.publisher)) {
      return [];
    }

    return [
      {
        publisher: cvm?.publisher,
        publisher_addr: cvm?.publisher_addr,
      },
    ];
  };

  const getPublisherBubbleContent = (cvm: any) => {
    const publisherList = getPublisherInfoList(cvm);

    if (!publisherList.length) {
      return undefined;
    }

    return (
      <div className="dbi-firstRow-publisher-bubble-content">
        <span className="dbi-firstRow-publisher-bubble-label">
          {formatMessage({ id: 'dbi_publisher' })}:
        </span>
        <span className="dbi-firstRow-publisher-bubble-list">
          {publisherList.map((item: IPublisherInfoItem, index: number) => (
            <span
              className="dbi-firstRow-publisher-bubble-item"
              key={`${item?.publisher}-${item?.publisher_addr}-${index}`}
            >
              <img className="dbi-firstRow-publisher-bubble-flag" src={getCountryFlag(item?.publisher_addr)} alt="" />
              <span className="dbi-firstRow-publisher-bubble-name">{item?.publisher}</span>
              {index !== publisherList.length - 1 && (
                <span className="dbi-firstRow-publisher-bubble-comma">,</span>
              )}
            </span>
          ))}
        </span>
      </div>
    );
  };

  const getMetricCloums = () => {
    let metricCloums: any[] = [];
    // const titles = getPCConsoleCloumsByPageId(entityType, pageId);
    // Filter out game_engine as it will be rendered separately before Actions column
    const filteredColumns = dataSourcesColumns.filter(
      (t) => t?.metricKey !== 'game_engine' && t?.value !== 'game_engine',
    );
    filteredColumns.forEach((t) => {
      metricCloums.push(
        MetricsTableCloums({
          /** MetricsTable页只有降序功能 */
          onlySimpleSort: false, // pageId === 'MetricsTable' ? true : false,
          renderType: t?.renderType,
          width: t?.width,
          width_cn: t?.width_cn,
          icon: t?.icon,
          orderDataSource: t?.metricValue ?? t?.dataSource,
          dataSource: t?.dataSource, // source === 'ogdb' ? 'databarin' : source,
          title: t?.text,
          textContent: t?.info,
          tipText: pageId === 'MetricsTable' ? undefined : t?.iconInfo,
          key: `${t?.value}_${t?.dataSource}`,
          sortMetric: t?.value,
          metricKey: t?.metricKey || t?.value,
          currentSortValue,
          currentSortKey: `${currentSortMetric}_${
            currentOrderSource === 'famitsu rank'
              ? 'famitsu'
              : currentOrderSource
          }_${currentRatioType}`,
          onSortChage,
          dateType,
          startDate,
          endDate,
          pageId,
          getMetricValueOfCvm,
          formatMessage,
          sortByList: t?.value === 'meta_score' ? deviceSortByList : [],
          disabledSort: t?.disabled,
          orderDevice: currentOrderDevice,
          dataSourceType: t?.dataSourceType || t?.dataSource,
          isNoDropdown: t?.isNoDropdown,
          entityType,
          // steam tag、game mode 列单元格中点击 tag 修改值并请求
          onTagClick,
          svgTipIsNoMore: t?.isNoMore,
          svgTipIsNewMore: t?.newMore,
          hideBubbleLeadingIcon: t?.hideBubbleLeadingIcon,
          onMetricExplanationClick,
        }),
      );
    });
    // 现在 MetaCritic Score(Global) 已经是固定的表格了，所以这里需要过滤掉meta_score_metacriticMetaCritic Score 这个列
    metricCloums = metricCloums.filter(
      (ele) => ele.key !== 'meta_score_metacriticMetaCritic Score',
    );
    return metricCloums;
  };

  // Check if game_engine column exists in dataSourcesColumns
  const hasGameEngineColumn = dataSourcesColumns.some(
    (t) => t?.metricKey === 'game_engine' || t?.value === 'game_engine',
  );

  // Game Engine column - positioned before Actions column
  const getGameEngineColumn = () => {
    if (!hasGameEngineColumn) return [];

    return [
      CommonColumns.GameEngineColumn({
        formatMessage,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onTagClick,
      }),
    ];
  };

  const getPublisherClassColumn = () => {
    if (!['PCConsoleMetricsTable', 'PCConsoleDataBrainCalibration'].includes((pageId))) {
      return [];
    }

    return [
      {
        key: 'publisher_class',
        header: formatMessage({ id: 'dbi_publisher_class' }),
        width: 154,
        align: 'left',
        render: (cvm: any) => {
          const publisherClass = cvm?.publisher_class;
          if (isEmpty(publisherClass)) {
            return '-';
          }
          return getPublisherClassText(publisherClass, formatMessage);
        },
      },
    ];
  };

  const getSteamsalesCloums = () => {
    const releaseTime = {
      key: 'release_time',
      header: (
        <CloumsCenter width={160} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_release_date' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 180,
      render: (cvm: any) => {
        const releaseTime = formatReleaseTime(locale, {
          isSpecialReleaseTime: cvm?.is_special_release_time,
          releaseTime: cvm?.release_time,
          releaseTimeEN: cvm?.release_time_en,
          releaseTimeCN: cvm?.release_time_cn,
        });
        return (
          <CloumsCenter width={160} align="left">
          <span className="dbi-ellipsis">
            {releaseTime || '-'}
          </span>
          </CloumsCenter>
        );
      },
    };
    const publisher = {
      key: 'publisher',
      header: (
        <CloumsCenter width={180} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_publisher' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 180,
      render: (cvm: any) => (
        <CloumsCenter width={180} align="left">
          {cvm.publisher || '-'}
        </CloumsCenter>
      ),
    };
    const developer = {
      key: 'developer',
      header: (
        <CloumsCenter width={180} align="left">
          <div className="header-other">
            {formatMessage({ id: 'dbi_developer' })}
          </div>
        </CloumsCenter>
      ),
      align: 'center',
      width: 180,
      render: (cvm: any) => (
        <CloumsCenter width={180} align="left">
          {cvm.developer || '-'}
        </CloumsCenter>
      ),
    };
    if (pageId === 'SteamSales') {
      return [releaseTime, publisher, developer];
    }
    return [releaseTime];
  };

  const getDetailGamePath = (gameId: string, queryParams = jumpQuery) => {
    const { metrics, ...query } = queryParams || {};
    const path = getDetailGamePathCommon({
      entityType,
      gameId,
      tab: 'stats',
      subTab: getDetailStatsSubTabName(entityType, pageId),
      query,
    });

    if (!metrics) {
      return path;
    }

    const separator = path?.includes('?') ? '&' : '?';
    return `${path}${separator}metrics=${encodeURIComponent(metrics)}`;
  };

  const getFilterParams = useCallback(() => {
    const {
      rangeTime = {},
      composed_country_select = {},
      metric_selection_for_trends = {},
    } = filterExtend || {};

    return {
      start_date: rangeTime?.start_date || rangeTime?.value?.[0] || '',
      end_date: rangeTime?.end_date || rangeTime?.value?.[1] || '',
      format_date: false,
      granularity: rangeTime?.type || '',
      region: composed_country_select?.value?.countries || [],
      metrics:
        Object.entries(
          metric_selection_for_trends?.value?.source_metrics || {},
        )
          .map(([k, v]) => `${k}::${Array.isArray(v) ? v.join(',') : v}`)
          .join(';;') || '',
    };
  }, [filterExtend]);

  const filterParams = useMemo(() => getFilterParams(), [getFilterParams]);

  const onClickGame = async (gameId: string, queryParams = jumpQuery) => {
    // 如果操作了筛选器 , LifeTimePlayers跳转到详情时间需要往前推几个月
    if (pageId === 'LifeTimePlayers' && isOperate) {
      const updateTimeFilter = changeSingleTimeToRange({
        timeType: 'month',
        subtractNum: 5,
        filterExtend,
      });
      setFilterExtend(updateTimeFilter);
    }

    const url = getDetailGamePath(gameId, queryParams);

    navigate(url, {
      jumpType,
      windowParams: jumpType === JumpType.Window ? filterParams : undefined,
    });
  };

  if (!loading) {
    const tableNode = document.querySelector(
      '#topchart-metrics-table .tea-table .tea-table__body',
    );
    if (tableNode) {
      tableNode.addEventListener('scroll', () => {
        if (showShadow !== tableNode?.scrollLeft > 0) {
          setShowShadow(tableNode?.scrollLeft > 0);
        }
      });
      tableNode.removeEventListener('scroll', () => {});
    }
  }

  useEffect(() => {
    getPriceEcharts(records, dateType);
  }, [records, dateType]);

  return (
    <div
      className={classNames('dbi-table-content', {
        'table-sticky-two': true,
        'table-sticky-two-shadow': showShadow,
      })}
      id="topchart-metrics-table"
    >
      <TopchartTable
        recordKey={'app_id'}
        loading={loading}
        records={records}
        tableTotal={tableTotal}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        columns={[
          {
            key: 'select',
            width: 36,
            // fixed: 'left',
            header: () => (
              <TableCheckboxHeader
                selectList={selectList}
                disableChckekList={disableChckekList || []}
                tableSelectionAll={tableSelectionAll}
                disabled={loading || records.length === 0}
                onChange={(list, stats) => {
                  if (stats === 'cancel' && disableChckekList?.length) {
                    // 取消时，禁止取消的列表不能被取消
                    const checkList =
                      tableSelectionAll?.filter((cvm) =>
                        disableChckekList?.includes(cvm?.app_id),
                      ) || [];
                    onTableCheckGame(checkList, 'del');
                    setSelectList(checkList);
                  } else {
                    onTableCheckGame(list, stats);
                    setSelectList(list);
                  }
                }}
              />
            ),
            render: (cvm: any) => {
              const gameNodataDisable = getGameRankDetails(
                cvm?.rank,
              ).isDisabled;
              const customizeDisable = disableChckekList?.includes(cvm?.app_id);
              return (
                <TableCheckboxRender
                  selectList={selectList}
                  cvm={{ ...(cvm || {}), gameId: cvm?.app_id }}
                  disabled={gameNodataDisable || customizeDisable}
                  bubbleContent={customizeDisable ? checkboxDisableTip : ''}
                  onChange={(list, status) => {
                    setSelectList(list);
                    onTableCheckGame(list, status);
                  }}
                />
              );
            },
          },
          {
            key: 'gametitle',
            width: 360,
            // fixed: 'left',
            header: (
              <div className="dbi-firstRow-flex">
                <div className="dbi-text-id">#</div>
                <Bubble
                  dark
                  arrowPointAtCenter
                  content={
                    pageId !== 'MetricsTable'
                      ? undefined
                      : formatMessage({
                          id:
                            entityType === 'pc'
                              ? 'dbi_metrictable_pc_game_info'
                              : 'dbi_metrictable_console_game_info',
                        })
                  }
                >
                  <div
                    style={{
                      marginRight: 8,
                      cursor: pageId !== 'MetricsTable' ? 'normal' : 'pointer',
                    }}
                  >
                    {formatMessage({ id: 'dbi_top_gametitle' })}
                  </div>
                </Bubble>
                {/* {pageId === 'MetricsTable' && (
                  <TipContext
                    tipText={formatMessage({
                      id:
                        entityType === 'pc'
                          ? 'dbi_metrictable_pc_game_info'
                          : 'dbi_metrictable_console_game_info',
                    })}
                  />
                )} */}
              </div>
            ),
            render: (cvm: any) => {
              // 获取device的icon，排序先pc的device再console的device
              const platformSource: string[] = cvm?.platform || [];
              const platformOrder = [
                'steam',
                'epic',
                'pc',
                'ps',
                'xbox',
                'nintendo',
              ];
              const platformIcon = iconSortFun(platformSource, platformOrder);

              let icons = getPlatformIconsImg(platformIcon);
              icons = Array.from(new Set(icons));

              // 获取entity的icon，排序先pc再console
              const order = ['mobile', 'pc', 'console'];
              const entityIcons: string[] = iconSortFun(
                Array.from(new Set(cvm?.entity_icon)),
                order,
              );

              return (
                <FirstRow
                  id={getGameRankDetails(cvm?.rank)?.rankText}
                  cvm={{
                    imgType: entityType,
                    img: cvm?.cover,
                    gametitle: cvm?.name,
                    countryIcon: getCountryFlag(cvm?.publisher_addr),
                    text: cvm?.publisher,
                    subInfoBubbleContent: shouldShowPublisherHoverBubble && getPublisherBubbleContent(cvm),
                    databrainIconTip: <DatabrainBubbleTip />,
                    icon: entityType === 'pc' ? null : icons,
                    entityIcon:
                      entityType === 'combine' && cvm?.entity_icon?.length ? (
                        <>
                          {entityIcons?.map((plat: string) => (
                            <a
                              className="dbi-pcconsole-table-firstrow"
                              key={cvm?.plat}
                            >
                              <SvgIcon
                                className="dbi-pcconsole-table-entityicon"
                                type={plat === 'pc' ? 'monitor' : 'game'}
                              />
                            </a>
                          ))}
                        </>
                      ) : null,
                  }}
                  rihgtClickToJumpHref={getDetailGamePath(cvm?.app_id, gameInfoJumpQuery)}
                  onClick={() => {
                    onClickGame(cvm?.app_id, gameInfoJumpQuery);
                  }}
                />
              );
            },
          },
          ...getMetricCloums(),
          ...getSteamsalesCloums(),
          CommonColumns.GenreColumn({
            locale,
            genreSource,
            genreOptionsMap,
            mainGenreField: 'genre',
            subGenreField: 'sub_genre',
          }),
          ...getGameEngineColumn(),
          ...getPublisherClassColumn(),
          DetailsCloums({
            onClickGame: (cvm: any) => {
              onClickGame(cvm?.app_id);
            },
            formatMessage,
          }),
        ]}
        tableAddons={[
          // 支持 props 注入
          injectable({
            row: (props, context) => ({
              // 添加高亮游戏样式
              className: gameHightList?.includes(context.rowKey)
                ? 'dbi-table-hight-row'
                : '',
            }),
          }),
        ]}
      />
    </div>
  );
}
